
import Vue from 'vue'
import Component from 'vue-class-component'

// import { setSStorageInfo } from '@/common'
@Component({})
export default class IndexView extends Vue {}
